import api from './api';

export const projectService = {

  getProjects: async () => {
    try {
      const response = await api.get('/projects/');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Detalhe consolidado do projeto (recomendado).
   * GET /api/projects/{id}/?scan_limit=&include_archived=
   * Retorna cadastrais no root + people, map, alerts, downloads, etc.
   */
  getProjectById: async (projectId, options = {}) => {
    const params = {};
    if (options.include_archived) params.include_archived = true;
    if (options.scan_limit != null) params.scan_limit = options.scan_limit;

    const response = await api.get(`/projects/${projectId}/`, { params });
    return response.data;
  },

  getProjectByUserId: async (userId, filters = {}) => {
    try {
      const response = await api.get(`/projects/${userId}/by_user/`, { params: filters });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Hub consolidado do projeto (pessoas, mapa, downloads, áreas, alertas…).
   * GET /api/projects/{projectId}/hub/
   */
  getProjectHub: async (projectId, options = {}) => {
    const params = {};
    if (options.include_archived) params.include_archived = true;
    if (options.scan_limit != null) params.scan_limit = options.scan_limit;

    const response = await api.get(`/projects/${projectId}/hub/`, { params });
    return response.data;
  },

  // outro método usado
  //   axios.get( `/project/${user.id}/get_project_by_user/`,  { headers } );

  getProjectTokensByYears: async (requestData, token) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const response = await api.post('/project_tokens/get_by_years', requestData, { headers });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getProjectDocuments: async (filters = {}) => {
    try {
      const response = await api.get('/documentmodels/', { params: filters });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getProjectTokensByMonths: async (requestData, headers = {}) => {
    try {
      const response = await api.post('/project_tokens/get_by_months', requestData, { headers });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getAllSdgsByProject: async (projectId, token) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };

      const response = await api.get(
        `/project/${projectId}/get_all_sdgs_by_project/`,
        { headers }
      );

      return response.data;
    } catch (error) {
      console.error('❌ Erro ao buscar ODS do projeto:', error);

      if (error.response) {
        console.error('Status:', error.response.status);
        console.error('Dados:', error.response.data);
      }

      throw error;
    }
  },

  // services/projectService.js
  getProjectAreas: async (projectId) => {
    try {
      const token = sessionStorage.getItem("access_token");
      const response = await api.get(`/api/projects/${projectId}/areas/`, {  // Note a barra no final
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar áreas do projeto:', error);

      // Trate diferentes tipos de erro
      if (error.response) {
        if (error.response.status === 404) {
          throw new Error('Projeto não encontrado');
        } else if (error.response.status === 401) {
          throw new Error('Não autorizado. Faça login novamente.');
        }
      }

      throw error;
    }
  },

  createCompleteProject: async (projectData) => {

    try {
      const response = await api.post('/projects/create_complete/', projectData, {
        headers: {
          "Content-Type": "multipart/form-data"
        },
        timeout: 60000
      });

      return {
        ...response.data,
        _status: response.status,
        _headers: response.headers
      };

    } catch (error) {
      console.error('🔥 Serviço: Erro na requisição:', error);

      if (error.response) {
        console.error('📋 Serviço: Resposta de erro:', error.response.data);
        console.error('📊 Serviço: Status do erro:', error.response.status);

        // Re-lançar o erro com informações completas
        const enhancedError = new Error(error.response.data?.message || error.message);
        enhancedError.response = error.response;
        enhancedError.status = error.response.status;
        throw enhancedError;
      } else if (error.request) {
        console.error('📡 Serviço: Sem resposta do servidor');
        const noResponseError = new Error("Sem resposta do servidor. Verifique sua conexão.");
        noResponseError.request = error.request;
        throw noResponseError;
      } else {
        console.error('💡 Serviço: Erro na configuração:', error.message);
        throw error;
      }
    }
  },

  createProject: async (projectData) => {
    try {
      const response = await api.post('/projects/', projectData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  postSdgsByProject: async (projectId, sdgs = []) => {
    try {
      const response = await api.post('/project/post_sdgs_by_project/', {
        project_id: Number(projectId),
        sdgs
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateProject: async (projectId, formData) => {
    try {
      const response = await api.patch(
        `/projects/${projectId}/update/`,
        formData
      );

      return response.data;
    } catch (error) {
      console.error('❌ Erro ao atualizar projeto:', error);

      if (error.response) {
        console.error('Status:', error.response.status);
        console.error('Dados:', error.response.data);
        console.error('Headers:', error.response.headers);
      }

      throw error;
    }
  },


  /**                       ENGENEERING                     */

  /**
   * Garante registro OneToOne de EnvironmentalEngineering para o projeto.
   * Não envia `status` (campo inexistente no model). Se já existir, reutiliza.
   */
  ensureEngineeringRecord: async (projectId) => {
    const listRes = await api.get(`/engineering/project/${projectId}/`);
    const existing = Array.isArray(listRes.data)
      ? listRes.data[0]
      : listRes.data?.results?.[0] || listRes.data?.[0];
    if (existing?.id) return existing;

    try {
      const response = await api.post('/engineering/', { project: projectId });
      return response.data;
    } catch (error) {
      // Corrida / já criado: trata Unique como sucesso e rebusca
      const status = error.response?.status;
      const data = error.response?.data;
      const projectErr = data?.project;
      const errText = Array.isArray(projectErr)
        ? projectErr.join(" ").toLowerCase()
        : String(projectErr || data || "").toLowerCase();
      const isUnique =
        status === 400 &&
        (errText.includes("unique") ||
          errText.includes("único") ||
          errText.includes("unico") ||
          errText.includes("already exists") ||
          errText.includes("já existe"));

      if (isUnique || status === 409) {
        const retry = await api.get(`/engineering/project/${projectId}/`);
        const again = Array.isArray(retry.data) ? retry.data[0] : retry.data?.[0];
        if (again?.id) return again;
      }

      console.error('❌ Erro ao criar registro de engenharia:', error);
      throw error;
    }
  },

  /** @deprecated Use ensureEngineeringRecord — mantido para compatibilidade */
  createEngineeringRecord: async (projectId, _token) => {
    return projectService.ensureEngineeringRecord(projectId);
  },

  getEngineeringById: async (engineeringId, token) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const response = await api.get(`/engineering/${engineeringId}/`, { headers });
      return response.data;
    } catch (error) {
      console.error(`❌ Erro ao buscar engenharia ${engineeringId}:`, error);
      throw error;
    }
  },


  downloadEnvironmentalFile: async (projectId, fileField, password, token) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };

      const response = await api.post(
        `/environmental-engineering/${projectId}/download/${fileField}/`,
        { password },
        {
          headers,
          responseType: 'blob',
        }
      );

      return response.data; // retorna o blob
    } catch (error) {
      console.error(`❌ Erro ao baixar arquivo (${fileField}) do projeto ${projectId}:`, error);
      throw error;
    }
  },

  sendFilesUpload: async (doc, _token, onUploadProgress = null) => {
    try {
      const usuarioId = sessionStorage.getItem('usuario_id');
      const response = await api.post(
        '/sendfilesupload/',
        { file_states: doc },
        {
          params: usuarioId ? { usuario_id: usuarioId } : undefined,
          onUploadProgress,
        }
      );

      return response.data;
    } catch (error) {
      console.error('❌ Erro ao enviar arquivos:', error);
      throw error;
    }
  },

  /**                               TOKENS                                    */
  getProjectTokens: async (token) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const response = await api.get('/project_tokens/select', { headers });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao buscar tokens de projeto:', error);
      throw error;
    }
  },

  createProjectToken: async (data, token) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const response = await api.post('/project_tokens/insert', data, { headers });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao criar token de projeto:', error);
      throw error;
    }
  },

  updateProjectToken: async (id, data, token) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const response = await api.put(`/project_tokens/update/${id}/`, data, { headers });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao atualizar token de projeto:', error);
      throw error;
    }
  },

  deleteProjectToken: async (id, token) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };
      await api.delete(`/project_tokens/${id}/delete`, { headers });
    } catch (error) {
      console.error('❌ Erro ao deletar token de projeto:', error);
      throw error;
    }
  },

  retireProjectToken: async (id, token) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const response = await api.put(`/project_tokens/aposentar_item/${id}/`, {}, { headers });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao aposentar token de projeto:', error);
      throw error;
    }
  },

  getProjectTokensBySearch: async (searchTerm, token) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const url_ = searchTerm
        ? `/project_tokens/select_by_token/${searchTerm}`
        : '/project_tokens/select';
      const response = await api.get(url_, { headers });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao buscar tokens filtrados de projeto:', error);
      throw error;
    }
  },

  /**                  PROJECT CARBON CREDIT                     */

  insertProjectCarbonCredit: async (formData, token) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const response = await api.post('/project_carbon_credits/insert', formData, { headers });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao inserir crédito de carbono do projeto:', error);
      throw error;
    }
  },

  updateProjectCarbonCredit: async (id, formData, token) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const response = await api.put(`/project_carbon_credits/update/${id}/`, formData, { headers });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao atualizar crédito de carbono do projeto:', error);
      throw error;
    }
  },

  deleteProjectCarbonCredit: async (id, formData, token) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const response = await api.delete(`/project_carbon_credits/${id}/delete/`, {
        headers,
        data: formData, // ⚠️ necessário para enviar body com DELETE
      });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao excluir crédito de carbono do projeto:', error);
      throw error;
    }
  },

  getProjectCarbonCredits: async (token) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const response = await api.get('/project_carbon_credits/select', { headers });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao buscar créditos de carbono:', error);
      throw error;
    }
  },

  /**
   * 🔹 Buscar créditos de carbono filtrando pela safra
   */
  getProjectCarbonCreditsBySafra: async (safra, token) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const response = await api.get(`/project_carbon_credits/select_by_safra/${safra}`, { headers });
      return response.data;
    } catch (error) {
      console.error(`❌ Erro ao buscar créditos de carbono para a safra ${safra}:`, error);
      throw error;
    }
  },

};
